module.exports = __webpack_public_path__ + "static/media/Carosel HO 2.35e0461d.svg";